// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2CGFC","inner":"Footer_inner__3KoQN"};